import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Chart, registerables } from 'chart.js';
import { AppConfig, bootsInSsoMode } from './app/core/services/app-config.service';

// ng2-charts v4 has no provideCharts(); register Chart.js controllers/elements globally once.
Chart.register(...registerables);

async function tryFetch(relPath: string): Promise<Partial<AppConfig> | null> {
  try {
    const res = await fetch(new URL(relPath, document.baseURI).toString(), { cache: 'no-store' });
    return res.ok ? await res.json() : null;
  } catch {
    return null;
  }
}

/**
 * The SSO stack (AppSsoModule) hangs every HttpClient call when the user is not
 * signed in, so the root module is picked per tab BEFORE Angular starts: the same
 * runtime config AppConfigService will load again decides which stack boots.
 */
async function bootstrap(): Promise<void> {
  const cfg = (await tryFetch('assets/config.local.json')) ?? (await tryFetch('assets/config.json'));
  if (bootsInSsoMode(cfg)) {
    const { AppSsoModule } = await import('./app/app-sso.module');
    await platformBrowserDynamic().bootstrapModule(AppSsoModule);
  } else {
    const { AppModule } = await import('./app/app.module');
    await platformBrowserDynamic().bootstrapModule(AppModule);
  }
}

bootstrap().catch((err) => console.error(err));
